import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParamsService {
  get = new BehaviorSubject<any>(null);
  params!: HttpParams;

  constructor(
    private RT: Router,
    private AR: ActivatedRoute,
  ) {
    this.AR.queryParams.subscribe((params: Params) => {
      let prms: HttpParams = new HttpParams();
      Object.keys(params).forEach(function (key) {
        prms = prms.append(key, params[key]);
      });
      this.params = prms;
      this.get.next(true);
    });
  }

  /**
   * Limpia todos los params de la url
   * @author Martin Batun Tec.
   */
  clean(): void {
    let prms: any;
    this.params.keys().forEach((key) => {
      prms = { ...prms, ...{ [key]: null } };
    });
    this.set(prms);
  }

  /**
   * Setea nuevos params a la url.
   * @param prms params a setear
   * @author Martin Batun Tec.
   */
  set(prms: any): void {
    const urlTree = this.RT.createUrlTree([], {
      queryParams: prms,
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });
    this.RT.navigateByUrl(urlTree);
  }

  /**
   * obtiene en un array todos los params disponibles
   * @return Array de params disponibles
   * @author Martin Batun Tec.
   */
  get array(): Array<{ param: string; value: any }> {
    let prms = this.params['map'] ? this.params['map'] : this.params['updates'];
    return (prms = prms && Array.isArray(prms) ? prms : []);
  }
}
